<template>
	<div class="card" :class="[{ [suit]: shown }, shown ? 'shown' : 'hidden']">
		<template v-if="shown">
			<span class="value-symbol">{{ value }}</span>
			<span class="suit-symbol" v-html="emojify(suit)"></span>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		value: String,
		suit: String,
		shown: Boolean,
	},
	methods: {
		emojify(str) {
			switch (str) {
				case "clubs":
					return "&clubs;";
				case "diamonds":
					return "&diams;";
				case "hearts":
					return "&hearts;";
				case "spades":
					return "&spades;";
				default:
					return str;
			}
		},
	},
};
</script>

<style scoped lang="scss">
@import "../assets/scss/main.scss";

.card {
	vertical-align: top;
	display: inline-block;
	box-shadow: 0px 4px 20px #1032;
	&,
	&:active {
		border: 1px solid $blue-darkest;
	}
	border-radius: 10px;
	z-index: 10;
	&.shown {
		width: 80px;
		padding: 12px;
		padding-right: 40px;

		background-color: white;

		text-align: center;
		font-weight: bold;
		font-size: 20px;

		&.spades,
		&.clubs {
			color: $blue-darker;
		}
		&.hearts,
		&.diamonds {
			color: $red;
		}

		.suit-symbol {
			display: block;
		}

		cursor: pointer;

		&:hover {
			background: rgb(230, 235, 241);
		}
		&:active {
			background: rgb(212, 225, 241);
		}
		&.last-taken {
			width: 80px;
			height: 120px;
		}
	}
	min-height: 100%;

	&.hidden {
		background-color: $card-red;
		width: 64px;
	}
}
</style>
